import {FocusHandlerState} from '../reducers/focus-handler'

export const getActiveElement = (state: FocusHandlerState) => state.activeElement
